import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import apiService from '../../services/ApiService';

export default function SafetyActions({ username }: { username: string }) {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (user?.username === username) return null;
  const report = '/support?report=' + encodeURIComponent('https://biltspec.com' + window.location.pathname);
  return <div className="flex flex-wrap gap-3 items-center px-4 py-4 text-sm">
    <Link className="text-zinc-400 underline min-h-[44px] inline-flex items-center" to={report}>Report content</Link>
    {isAuthenticated && !confirming && <button className="text-zinc-400 underline min-h-[44px]" onClick={() => setConfirming(true)}>Block @{username}</button>}
    {confirming && <div className="rounded-lg border border-white/10 p-4 space-y-3" role="group" aria-label="Confirm block">
      <p>Block @{username}? Their builds and updates will be hidden from your signed-in account. They will not be notified. You can undo this in Support and safety.</p>
      <button className="min-h-[44px] text-orange-300 mr-4" disabled={busy} onClick={() => {
        setBusy(true); setError('');
        void apiService.makeRequest('/user_safety.php', { method: 'POST', body: JSON.stringify({ action: 'block', username }) }).then(response => {
          if (!response.success) throw new Error(response.error || 'Could not block member');
          navigate('/support?blocked=1');
        }).catch(e => setError(e instanceof Error ? e.message : 'Could not block member')).finally(() => setBusy(false));
      }}>{busy ? 'Blocking…' : 'Confirm block'}</button>
      <button className="min-h-[44px] text-zinc-400" disabled={busy} onClick={() => setConfirming(false)}>Cancel</button>
      {error && <p role="alert" className="text-red-300">{error}</p>}
    </div>}
  </div>;
}
